import selectric from "selectric"
import axios from "axios"
import querystring from "querystring"
import ReportForm from "./report-form.js"

class App {

    constructor() {
        this.el = document.querySelector('.el')
        this.listeners()
        this.init()
        this.post_type = "aktuellt" // for nice searching
        this.searchParams = {
            action:    '',
            sort:      '',
            stiftelse: '',
            post_type: '',
            year:      ''
        }
    }

    /**
     * logic for change password
     */
    setup_memberSettingsPage() {
        $('#change_password').click(function(e) {
            e.preventDefault();
            // first check so both inputs match
            if($("#input-new_password1").val() != $("#input-new_password2").val()) {
                $("#change_password_response").fadeIn(1000).html("Lösenorden matchar inte")
                return false;
            }

            axios.get(ajax_url, {
                params: {
                    action: 'mats_changepassword',
                    old_password: $('#input-current_password').val(),
                    new_password: $('#input-new_password1').val()
                }
            }).then(function(response) {
                $("#change_password_response").fadeIn(1000).html(response.data.data + ". <strong>Du kommer nu att behöva logga in igen med ditt nya lösenord.</strong>");
                setTimeout(() => {
                    window.location.href="/"
                }, 5000);
            });
        });
    }

    /**
     * fix profile builder to match layout.
     */
    setup_loginAndRegister() {

            $('#send_credentials_via_email').parents('.wppb-form-field').remove()
            $('#wppb_register_pre_form_message').remove()


        // remove fakutet and titel if they should not be shown when register new user
        if($('body').hasClass('page-id-39')) {
            $('.page-id-39').find('#wppb-form-element-14, #wppb-form-element-15').remove()
        }
        $('.text-input').parents('form').attr('autocomplete', 'off')

        // fix layout for login page
        $('[name="loginform"]').find('.login-username, .login-password').each(function () {
            $(this).find('input').addClass('text-input')
            var x = $(this).html()
            $(this).replaceWith('<div class="wppb-form-field clearfix">' + x + '</div>')

        })

        $('.extra_field_input ').addClass('text-input')
        $('label:empty').remove();

        // check value if value alreay exist
        $('.text-input').each(function () {
            if ( $(this).val().length ) {
                $(this).parent().addClass('active')
            }
        })

        // animation for label
        $('.text-input').focus(function () {
            $(this).parent().addClass('active')
        }).blur(function () {
            if ( !this.value ) {
                $(this).parent().removeClass('active')
            }
            else {
                $(this).parent().addClass('active')
            }
        })
    }

    /**
     * different setup for filtering, sorting and searching on aktuellt and utdelningar page.
     */
    setup_filtersForSearch() {

        function addTagbutton(value, selector) {
            var value = value
            //checkvalue(value);
            $('.filter-tag__inner').show()
            $('.filter-tag__inner').append('<button class="btn btn-primary btn--radial btn--black btn--solid  btn--sm filter-tag__btn ' + selector + '"> <span class="js-tag">' + value + '</span> <span class="filter-tag__remove js-remove"></span></button>')
        }

        let valuetracking = []

        function checkvalue(value) {
            if ( valuetracking.length === 0 ) {
                valuetracking.push(value)
            }
            else if ( valuetracking.length > 0 && !valuetracking.includes(value) ) {
                valuetracking.push(value)
            }
        }


        // this function removes all tags and then add correct tag depending on what is selected in the dropdowns.
        function updateTags() {
            $('.js-selectric-reset').siblings().remove()
            if ( $(".kategori-filter").val() != 'Alla utdelningar' ) addTagbutton($(".kategori-filter").val())


            $('.filter__component').each(function () {
                $(this).prop('selectedIndex', 0).selectric('refresh')
            })
        }

        function ajaxSearch() {
            axios.get(ajax_url, {
                params: {
                    action:    'mats_search',
                    category:  $(".kategori-filter").val(),
                    stiftelse: $(".stiftelse-filter").val(),
                    post_type: $("#ajax_content").data("post_type"),
                    year:      $(".year-filter").val(),
                    sort:      $(".sorting-filter").val()
                }
            }).then(function (response) {
                $("#ajax_content").html(response.data).fadeIn(500)
            })
        }

        $('.filter__component').selectric({
            maxHeight:       500,
            disableOnMobile: false,
            nativeOnMobile:  false
        })

        $('.filter__component').on('change', () => {
            $("#ajax_content").fadeOut(300, () => { $(this).empty() })
            ajaxSearch()
        })

        $('.kategori-filter').on('selectric-select', function (event, element, selectric) {
            let value = $(this).find('option:selected').html()
            let seletorClass = 'kategori-btn'
            $('.kategori-btn').remove()
            addTagbutton(value, seletorClass)

        })

        $('.stiftelse-filter').on('selectric-select', function (event, element, selectric) {
            let value = $(this).find('option:selected').html()
            let seletorClass = 'stiftelse-btn'
            $('.stiftelse-btn').remove()
            addTagbutton(value, seletorClass)

        })

        $('.year-filter').on('selectric-select', function (event, element, selectric) {
            let value = $(this).find('option:selected').html()
            let seletorClass = 'year-btn'
            $('.year-btn').remove()
            addTagbutton(value, seletorClass)
        })

        $('body').delegate('.kategori-btn .filter-tag__remove', 'click', function () {
            $(this).parent().remove()
            resetFilter('.kategori-filter')
        })

        $('body').delegate('.stiftelse-btn .filter-tag__remove', 'click', function () {
            $(this).parent().remove()
            resetFilter('.stiftelse-filter')
        })

        $('body').delegate('.year-btn .filter-tag__remove', 'click', function () {
            $(this).parent().remove()
            resetFilter('.year-filter')
        })

        //ie fix
        $(document).on('click', function(e){
            if($(e.target).hasClass('year-btn')){
                $(e.target).remove();
                resetFilter('.year-filter')
            }else if($(e.target).hasClass('stiftelse-btn')){
                $(e.target).remove();
                resetFilter('.stiftelse-filter')
            }else if($(e.target).hasClass('kategori-btn')){
                $(e.target).remove();
                resetFilter('.kategori-filter')
            }
        })




        function resetFilter(selector) {
            $(selector).prop('selectedIndex', 0).selectric('refresh')
            ajaxSearch();
        }

        $('.js-selectric-reset').on('click', () => {
            $('.js-selectric-reset').siblings().remove()
            $(".filter__component").prop('selectedIndex', 0)
            $('.filter__component').each(function () {
                $(this).prop('selectedIndex', 0).selectric('refresh')
            })
            ajaxSearch()
        })

        $('.js-filter-triger').on('click', function (e) {
            e.stopPropagation()
            if ( $(window).width() < 768 ) {
                $('.filter').toggle()
            }
        })
    }

    /**
     *  Setup for menu, submenu, hamburger
     */
    setup_menu() {
        // öppna/stäng hamburgaren
        $('.header').each(function () {
            $(this).find('.header__nav-button').on('click', function () {
                $('body').toggleClass('navOpen')
            })

            $(this).find('.hasSub .caret').on('click', function (e) {
                e.preventDefault();
                $(this).parents('li').toggleClass('open').find('.sub-menu').slideToggle()
            })
        })

        // lägg till undermenyer om det finns
        $('.primary-nav > li').find('.sub-menu').parent().addClass('hasSub')

        $(".primary-nav li.hasSub .caret").click(function(e){
            e.preventDefault();
            $(this).parent().siblings().slideToggle();
        });
    }

    /**
     * logic for resizing, stickyness etc. for header
     */
    setup_header() {

        // lite meckigt men fixa header on man resizar fönstret.
        var lastPos = 0,
            x = $('.header').clone()
        $('.header').after(x).addClass('fixTop')
        var getHeaderHeight = $('.header').outerHeight()

        $(window).resize(function () {
            getHeaderHeight = $('.header').outerHeight()
        })

        $('.fixTop').css('top', '-' + getHeaderHeight + 'px')

        // om man scrollar så byt mot den lilla headern
        $(window).scroll(function () {
            var wScroll = $(window).scrollTop()
            if ( wScroll > 100 ) {
                $('.fixTop').addClass('navFixed').css('top', 0)
                if ( wScroll < lastPos ) {
                    $('.fixTop').css('top', '-' + getHeaderHeight + 'px')
                }
                lastPos = wScroll
            }
            else {
                $('.fixTop').removeClass('is-scrolling')
                $('.fixTop').removeClass('navFixed').css('top', '-' + getHeaderHeight + 'px')
            }
        })
    }

    /**
     * logic for section "stiftelse" when user is able to click for donation information
     */
    setup_foundation() {
        let self = this
        $(window).resize(function () {
            self.foundationHover()
        })
        $(".section-donate").hide()
        $('.js-foundation').each(function () {
            var x = $(this).find('p').outerHeight()
            $(this).on('click', function () {
                $(".section-donate").show()
                $('.js-foundation').removeClass('active').find('.js-foundation-content').css('padding-bottom', '0')
                $(this).addClass('active').find('.js-foundation-content').css({
                    paddingBottom: x
                })
                let getHeadingText = $(this).find('.js-foundation-heading').text()
                $('.js-foundation-title').text(getHeadingText)

                let email = $(this).find('.hidden-email').text(),
                    banknumber = $(this).find('.hidden-banknumber').text(),
                    swisnumber = $(this).find('.hidden-swish-number').text(),
                    tagline = $(this).find('.hidden-tagline').text(),
                    tel = $(this).find('.hidden-phone-number').text(),
                    url = $(this).find('.hidden-url').text();

                   $('.js-donate-bank').text(banknumber);
                   $('.js-donate-swish').text(swisnumber);
                   $('.js-donate-tagline').text(tagline);
                   $('.js-donate-email').text(email).attr('href', 'mailto:' + email + '');
                   $('.js-donate-tel').text(tel).parent().attr('href', 'tel:' + tel + '');
                   $('.js-donate-stiftelse_url').attr('href', url);
                   console.log(tel)
            })
        })
    }

    /**
     * Used when foundations(stiftelser) is selected in section stiftelser
     */
    foundationHover() {
        $('.js-foundation').each(function () {
            var x = $(this).find('p').outerHeight()
            $(this).on('mouseenter', function () {
                $(this).find('.js-foundation-content').css({
                    paddingBottom: x
                })
            }).on('mouseleave', function () {
                if ( $(this).hasClass('active') ) {
                    $(this).find('.js-foundation-content').css({
                        paddingBottom: x
                    })
                }
                else {
                    $(this).find('.js-foundation-content').css('padding-bottom', '0')
                }
            })
        })
    }


    /**
     * Logic for section, "table of contents (innehållsförteckning)"
     */
    setup_tableOfConents() {
        // scroll on click
        $('a[href*="#"]:not([href="#"])').click(function () {
            if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
                var target = $(this.hash)
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
                if ( target.length ) {
                    $('html,body').animate({
                        scrollTop: target.offset().top
                    }, 1000)
                    return false
                }
            }
        })
    }

    /**
     * Profile accordion
     */
    setup_accordion() {
        $('.profile__title').on('click', function() {
            $(this).siblings().slideToggle().parent().toggleClass('open');

        })
    }

    /**
     * Add titles to form progressbar
     */
    setup_formStep() {
        let str = '<div class="step text-center"> <div class="container"> <div class="step__list d-flex flex-wrap mb-0"> </div> </div> </div>';
        $('.gf_progressbar_percentage ').html(str);

       $('.form-description h1').each(function(){
           var x = $(this).text();

            $('.step__list').append('<div class="step__item"> <em class="step__indicator">&nbsp;</em> <h6 class="heading-senary mb-0">' + x + '</h6> </div>')
        })
    }

    /**
     * just some smaller customizations
     */
    setup_gravityForms() {
        $('.gform_drop_instructions').html('Släpp filer här eller <span class="color-black" >välj filer</span>')
        $('.gfield_required').remove();
        $('.gfield_label:empty').remove();
        if ( $('.ginput_container_select').length ) {
            $('.ginput_container_select select').selectric({
                maxHeight:       500,
                disableOnMobile: false,
                nativeOnMobile:  false
            })
        }

        $('.gf_half ').wrapAll('<div class="has-column">');
        $('#wppb-register-user ul:first-child').append('<li class="text-left"><label for="read"><input type="checkbox" id="read" required /> I have read agreement<div class="checkbox"></div></label></li>')

    }

    /**
     * file upload progress and list
     */
    setup_fileUploadOption() {
          var file,
            formdata = new FormData();

          function uploadFile(e) {
            file = e.target.files[0];
            var fileName = file.name;
            formdata.append("file", file);
            var ajax = new XMLHttpRequest();
            ajax.upload.addEventListener("progress", progressHandler, false);
            ajax.addEventListener("load", completeHandler, false);
           // ajax.addEventListener("load", completeHandler, false);
            //ajax.addEventListener("error", errorHandler, false);
            //ajax.addEventListener("abort", abortHandler, false);
            ajax.open('POST', '../wp-content/themes/matspaulsson/inc/plugins/file_upload_parser.php');
            ajax.send(formdata);


            $('.fileupload-progress').css('display', 'block')
              $('.fileupload-progress__file').remove();
            $('.fileupload-progress__holder').append('<div class="fileupload-progress__file d-flex flex-wrap align-items-center"><div class="fileupload-progress__file-icon"></div><div class="fileupload-progress__file-name color-black">'+fileName+'<div class="fileupload-progress__bar"><div class="fileupload-progress__bar-inner"></div></div></div><button class="fileupload-progress__button fileupload-progress__buttton--cancel"></button> <button class="fileupload-progress__button fileupload-progress__button--delete""></button><div>');

          }

          function progressHandler(event) {
            var percent = (event.loaded / event.total) * 100;
            percent = Math.round(percent) + '%';

           $(".fileupload-progress__bar-inner").css('width', percent)
           $('.fileupload-progress__button--delete').css('display', 'none')

          }


          $(document).on('click', '.fileupload-progress__button--delete', function(){
                $(this).parent().remove();
                formdata.delete('file');
                $('#file_input').val('')

            })

          function completeHandler(event) {
            $(".fileupload-progress__bar").css('display', 'none')
            $('.fileupload-progress__button--delete').css('display', 'block')
           }

          $('#file_input').on('change', function(e){
            uploadFile(e);
          })


    }


     redirectUrl(){
         $("#report-submit").click(function () {
            var form = $(this).parents("form"),
                hostName = window.location.hostname;
            form.submit(function () {
                setTimeout(function(){
                    window.location.replace(hostName + '/oversikt');
                }, 2000)
            });
         });

     }

    setupInfoicon(){

        $('.input-group-title + .gform_hidden').each(function(){
            var getInfoValue = $(this).find('input[type="hidden"]').val();
            console.log(getInfoValue)
            $(this).prev().append('<div class="info__icon">? <div class="info__icon-text">'+getInfoValue+'</div></div>');
        })

    }

    changedCancelUrl() {
        var cancelBtn = $('.gv-button-cancel');
        if( $( cancelBtn ).length ) {
            $( cancelBtn ).attr('href', '/oversikt');
        }
    }

    // init page level dependencies
    initDependencies() {
        // here we should add check if on correct page and only load setup on them.
        this.setup_filtersForSearch();
        this.setup_loginAndRegister();
        this.setup_header();
        this.setup_menu();
        this.setup_foundation();
        this.setup_accordion();
        this.setup_formStep();
        this.setup_gravityForms();
        this.setup_memberSettingsPage();
        this.setup_tableOfConents();
        this.setup_fileUploadOption();
        this.setupInfoicon();
        this.changedCancelUrl();
    }

    /**
     * Main entrypoint
     */
    init() {
        this.initDependencies()

        if ( $(window).width() < 768 ) {
            $('body').on('click', function () {
                $('.filter').hide()
            })
        }
        this.handleMemberReportForm()
    }

    handleMemberReportForm() {
        let forms = $('.mats-member-report')
        forms.each(function () {
            new ReportForm($(this))
        })
    }

    listeners() {
        if ( this.el ) {
            this.el.addEventListener('click', this.elClick)
        }
    }

    elClick(e) {
        e.target.classList.add('text-light-grey')
        e.target.addEventListener('transitionend', (e) => ('color' === e.propertyName) ? e.target.classList.remove('text-light-grey') : '')
    }
}

export default App
